export const ScorecardWorkspace = {
  HEALTH: 'health',
  TITLES: 'titles'
} as const;
export type ScorecardWorkspaceType = (typeof ScorecardWorkspace)[keyof typeof ScorecardWorkspace];

export const ScoreMode = {
  HEALTH: 'health',
  ALEXA: 'alexa'
} as const;
export type ScoreModeType = (typeof ScoreMode)[keyof typeof ScoreMode];

export const DataMode = {
  EMPTY: 'empty',
  LIVE: 'live'
} as const;
export type DataModeType = (typeof DataMode)[keyof typeof DataMode];

export const STORAGE_KEY = 'pdp-scorecard-data-v1';

export interface ImportDiagnostics {
  total: number;
  missingRating: number;
  missingBullets: number;
  missingDescription: number;
  missingTitle: number;
  missingAplus: number;
  missingVideo: number;
}
